import React from "react";

const InfoRow = ({ label, value }) => (
  <div className="grid grid-cols-4 gap-4 ">
    <span className="text-black text-2xl leading-7 col-span-3">{label}</span>
    <span className="text-[#040404] text-[22px] leading-[26px] ">{value}</span>
  </div>
);

const StudentLearningInformation = ({
  plan = "Live Sessions",
  enrollmentDate = "Feb 5, 2025",
  expiryDate = "July 5, 2025",
  accessDuration = "5 Months",
}) => {
  return (
    <section className="rounded-xl border border-[#60555557] bg-white pt-6 pb-11 pl-9 pr-10">
      <h3 className="text-xl font-medium leading-[23px] text-black">Learning Information</h3>

      <div className="mt-[25px] space-y-[25px]">
        <InfoRow label="Plan" value={plan} />
        <InfoRow label="Enrollment Date" value={enrollmentDate} />
        <InfoRow label="Expiry Date" value={expiryDate} />
        <InfoRow label="Access Duration" value={accessDuration} />
      </div>
    </section>
  );
};

export default StudentLearningInformation;
